import { CustomStatusPanelProps } from 'ag-grid-react';
import { t } from 'i18next';
import { useEffect, useState } from 'react';

import { TotalPrice } from 'core/elements';
import { useAgGridServerTableContext } from 'core/states';

interface IProps extends CustomStatusPanelProps {
  totalLabel: string;
}

export const TotalsStatusBar = ({ totalLabel = t('labelReleaseValue') }: IProps) => {
  const [totals, setTotals] = useState<Record<string, number>>({});

  const { context } = useAgGridServerTableContext();

  useEffect(() => {
    if (context?.totals) {
      setTotals(context.totals);
    }
  }, [context]);

  const classNames = 'ag-status-name-value ag-status-panel';

  return <TotalPrice label={totalLabel} value={totals?.price} options={{ classNames }} />;
};
